import { Component, OnInit } from '@angular/core';
import { Tc } from '../../../core/_infrastructure/types/common';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ParametrosNuevaSolicitudCpeViewModel, SolicitudCpeViewModel } from '../datosbasicos/cpe.types';
import { SolicitudCpeService } from '../datosbasicos/cpe.service';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';

@Component({
    selector: 'app-tiposolicitudcpe-list',
    templateUrl: './tiposolicitudCpe-list.component.html',
})
export class TipoSolicitudCpeListComponent extends ComponentBase implements OnInit {
    listComunidad: Tc[];

    public isCollapsedDatos = false;
    IdComunidadAutonoma: number | null;
    solicitudCpe: SolicitudCpeViewModel;

    constructor(
        public datepipe: DatePipe,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private solicitudCpeService: SolicitudCpeService,
        private navMenuService: NavMenuService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit() {
        this.navMenuService.resetSolicitudData();

        this.globalService.getComunidadesAutonomas().subscribe(res => {
            this.listComunidad = res;
        });

        this.createForm();
    }

    createForm() {
        this.form = this.fb.group({
            IdCa: [null, Validators.required],
        });
    }

    onNext() {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        this.WriteParams();

        this.router.navigate(['/exportacion/cpe/datosbasicos/create']);
    }

    private WriteParams() {
        this.solicitudCpeService.currentParamNuevaSolicitudCpe = new ParametrosNuevaSolicitudCpeViewModel();

        this.solicitudCpeService.currentParamNuevaSolicitudCpe.IdCa = this.form.value.IdCa;
        //SET de los parametros de la nueva solicitud para guardarlos en el localStorage
        this.solicitudCpeService.setParamsSolicitudCpe(this.solicitudCpeService.currentParamNuevaSolicitudCpe);
    }

    onBack() {
        this.router.navigate(['/exportacion/cpes']);
    }
}
